const fontColor = function (a) {
  if (a === null) return 'has-text-white'

  let r, b, g, hsp

  if (a.length < 5) {
    a += a.slice(1)
  }

  if (a.match(/^rgb/)) {
    a = a.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)
    r = a[1]
    g = a[2]
    b = a[3]
  } else {
    // thanks to jed : http://gist.github.com/983661
    a = +('0x' + a.slice(1).replace(a.length < 5 && /./g, '$&$&'))

    r = a >> 16
    b = a >> 8 & 255
    g = a & 255
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
  )

  if (hsp > 200) {
    return 'has-text-grey'
  } else {
    return 'has-text-white'
  }
}

export default fontColor



// WEBPACK FOOTER //
// ./src/functions/fontColor.js